import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Widget, WidgetProps } from '../../../components';
import Project from './Project.component';
import { CustomerWithStatsDtoRead } from '@/store/services/MidleNestApi.service';

interface Props extends WidgetProps {
  projects?: CustomerWithStatsDtoRead[] | null;
}

export default function ProjectsList({ projects = [], ...props }: Props) {
  const { t } = useTranslation();

  return (
    <Widget
      actions={
        <>
          {/*<div className='flex lg:hidden items-center w-16 h-8 rounded-md border border-gray-200'>*/}
          {/*  <button*/}
          {/*    disabled={currentProject === 0}*/}
          {/*    onClick={() => setCurrentProject(currentProject - (getDevice === 'mobile' ? 1 : 2))}*/}
          {/*    className='w-1/2 h-full flex items-center justify-center disabled:pointer-events-none disabled:opacity-50 border-r border-gray-200'*/}
          {/*  >*/}
          {/*    <i className='icon-left-dir font-extrabold' />*/}
          {/*  </button>*/}
          {/*  <button*/}
          {/*    disabled={!projects || currentProject === projects?.length - 1}*/}
          {/*    onClick={() => setCurrentProject(currentProject + (getDevice === 'mobile' ? 1 : 2))}*/}
          {/*    className='w-1/2 h-full flex items-center justify-center disabled:pointer-events-none disabled:opacity-50'*/}
          {/*  >*/}
          {/*    <i className='icon-right-dir font-extrabold' />*/}
          {/*  </button>*/}
          {/*</div>*/}
          <div className='w-full block'>
            <Link
              className='text-blue-500 dark:text-[#FFDA68] font-medium text-sm hidden items-center lg:flex'
              to='/projects'
            >
              {t('View All')}
              <i className='icon-right-open-big mt-0.5 ml-1' />
            </Link>
          </div>
        </>
      }
      title={t('Projects')}
      {...props}
    >
      <table className='min-w-full dark:text-white'>
        <thead>
          <tr className='h-12 text-sm font-medium'>
            <td className=''>{t('Project Name')}</td>
            <td className='text-center'>{t('Active Tasks')}</td>
            <td className='text-center'>{t('Total Tasks')}</td>
            <td className='text-center'>{t('Total Points')}</td>
            <td className='text-center'>{t('Active Points')}</td>
          </tr>
        </thead>
        <tbody className='text-sm divide-y divide-gray-100 dark:divide-[#655A38]'>
          {projects?.map((i, k) => (
            <Project key={k} {...i} />
          ))}
        </tbody>
      </table>
    </Widget>
  );
}
